module.exports = __webpack_public_path__ + "static/media/dev-icon-3.c16cb739.svg";